<div
	class="tw:flex tw:flex-col tw:justify-center tw:items-center tw:gap-2 tw:text-secondary tw:p-2 tw:font-medium"
	[ngClass]="{
		'tw:[.active_&]:text-primary': !isInternalView,
		'tw:[.active_&]:text-purple': isInternalView,
	}"
>
	<mat-icon>{{ icon() }}</mat-icon>
	<ng-content></ng-content>
</div>
